import React, { useEffect, useState, useCallback } from 'react';
import Select from 'react-select';
import MessageGrid from '../purchaseRequisition/messageGrid';
import ApiService from '../../services/apiService';
import ItemGridGRN from './itemGrid';
import { toast } from 'react-toastify';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getCompany, getName, getUserId, getUserName } from '../../../Redux/selecters';
import { RiRefreshLine } from 'react-icons/ri';
import { FaSave } from 'react-icons/fa';
import { FaAngleLeft } from 'react-icons/fa6';
import { ClipLoader } from 'react-spinners';
import Modal from 'react-bootstrap/Modal';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import Attachment from '../Attachment/attachment';
import { useCurrency } from '../../../INVENTORY/Layouts/currencyContext';

const createEmptyRow = () => ({
    id: Date.now() + Math.random(),
    file: null,
    fileName: "",
    remarks: "",
});

const CreatePartialPO = () => {
    const [activeTab, setActiveTab] = useState(0);
    const REPORT_URL = process.env.REACT_APP_REPORTS_URL;
    const [gridVisibility, setGridVisibility] = useState([true, false, false]);
    const apiService = new ApiService();
    const [messageData, setMessageData] = useState([]);
    const [authorizationData, setAuthorizationData] = useState([]);
    const [ItemData, setItemData] = useState([]);
    const [PurchaseOrderDate, setPurchaseOrderDate] = useState();
    const { currencyPrecision } = useCurrency();

    const getCurrentLocalDatetime = () => {
        const localDate = new Date();
        const offset = localDate.getTimezoneOffset() * 60000;
        const localISOTime = new Date(localDate - offset).toISOString().slice(0, 16);
        return localISOTime;
    };

    const [POData, setPOData] = useState([]);
    const [selectedPOData, setSelectedPOData] = useState([]);
    const [usersDetails, setUser] = useState([]);
    const [WareHouse, setWareHouse] = useState([]);
    const [PurchaseOrder, setPurchaseOrder] = useState([]);
    const [POlist, setPOlist] = useState([]);
    const [SelectedPO, setSelectedPO] = useState([]);
    const [SelectedSupplier, setSelectedSupplier] = useState([]);
    const [SelectedCurrency, setSelectedCurency] = useState([]);
    const [grnNo, setGrnNumber] = useState([]);
    const location = useLocation();
    const navigate = useNavigate();
    const itemData = location.state;
    const userId = useSelector(getUserId);
    const userName = useSelector(getUserName);
    const Company = useSelector(getCompany);
    const [PurchaseTab, setPurchaseTab] = useState(true);
    const [CostTab, setCostTab] = useState(true);
    const [loader, setLoader] = useState(false);
    const [docModal, setDocModal] = useState(false);
    const onOpenModal = () => setDocModal(true);
    const onCloseModal = () => setDocModal(false);

    // Attachment
    const [attachmentModal, setAttachmentModal] = useState(false);
    const [previewModal, setPreviewModal] = useState(false);
    const [previewImage, setPreviewImage] = useState(null);
    const [attachments, setAttachments] = useState([createEmptyRow()]);
    const handleOpen = () => setAttachmentModal(true);
    const closeModal = () => setAttachmentModal(false);
    const isReadOnly = itemData?.eye === true;

    // New state for expense type and requisition
    const [expenseType, setExpenseType] = useState(null);
    const [requisitionList, setRequisitionList] = useState([]);
    const [selectedRequisition, setSelectedRequisition] = useState(null);
    const [isYusufCompany, setIsYusufCompany] = useState(false);
    const [isLoader, setIsLoader] = useState(false);
    const isRequisitionRequired = !!expenseType;
    const [overallDiscount, setOverallDiscount] = useState(0);
    const [discountAmount, setDiscountAmount] = useState(0);
    const [grandTotal, setGrandTotal] = useState(0);
    const [vatAmount, setVatAmount] = useState(0);
    const [supplierCheck, setSupplierCheck] = useState('Cancelled');

    const [formData, setFormData] = useState({
        paymentTerm: '',
        attention: '',
        vendorId: '',
        quotationRef: '',
        InvoiceDate: getCurrentLocalDatetime(),
        faxNo: '',
        vendorName: '',
        department: '',
        contactPerson: '',
        footNote: '',
        deliveryPoint: '',
        currency: '',
        exchangeRate: '',
        contactNo: '',
        costCenter1: '',
        costCenter2: '',
        costCenter3: '',
        costCenter4: '',
    });

    const DeliveryType = [
        { value: 'E-Ticket', label: 'E-Ticket' },
        { value: 'Hand Delivery', label: 'Hand Delivery' },
    ];

    const formatDateToDatetimeLocal = (dateString) => {
        const date = new Date(dateString);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        return `${year}-${month}-${day}T${hours}:${minutes}`;
    };

    useEffect(() => {
        fetchData();
        getApprovalUser();
    }, []);


    const fetchData = async () => {
        let param = `?DropdownFor=GetForPOsCancellation`
        const response = await apiService.getApiParamater('GET_PR_CASCAD', param);
        let data = response?.data?.items || []
        setPurchaseOrder(data);
    };

    const getApprovalUser = async () => {
        try {
            let docParam = `?TypeOfDoc=GRN&DocId=GRN`;
            let DocId = await apiService.getApiParamater('GET_DOC_ID', docParam);
            setGrnNumber(DocId?.data.result[0].docId);
            const params = new URLSearchParams();
            params.append('DocNo', '');
            params.append('DocumentType', 'GRN');
            const response = await apiService.getApiParamater('GET_DOC_STATUS_EDIT', `?${params.toString()}`);
            setUser(response.data.result);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const handleTabClick = (tabIndex) => {
        setActiveTab(tabIndex);
        const newGridVisibility = gridVisibility.map((_, index) => index === tabIndex);
        setGridVisibility(newGridVisibility);
    };

    const handleMessage = (data) => {
        setMessageData(data);
        console.log(data, 'reqData');
    };

    const handleRequisitionData = (data) => {
        setItemData(data);
        console.log(data, 'reqData');
    };

    const handleAuthorization = (data) => {
        setAuthorizationData(data);
        console.log(data, 'reqData');
    };

    const handlePoChange = async (selectedOption) => {
        let param = `?Id=${selectedOption?.label}`;
        const PurchaseOrder = await apiService.getApiParamater('GET_PO', param);
        setIsLoader(true)
        setPOlist(PurchaseOrder?.data?.result);
        let selectedpurchase = PurchaseOrder?.data?.result[0];
        const params = new URLSearchParams();
        params.append('POrderNo', selectedOption?.label || "");
        const res = await apiService.getApiParamater('GET_PO_REPORT', `?${params.toString()}`);
        const allData = res?.data?.result || [];
        if (selectedpurchase) {
            setSelectedPO(selectedOption);
            setSelectedPOData(selectedpurchase);
            const formattedRowsPromises = selectedpurchase?.poDetails?.map(async (detail, index) => {
                const selectedItem = allData?.find((itm) => itm.itemCode === detail?.itemCode && itm.itemDescription === detail?.itemDescription && itm.srNo === detail?.srno && itm.unitPrice === detail?.unitPrice);
                debugger
                return {
                    ...detail,
                    grnQty: selectedItem?.grnQty || 0,
                };
            })
                .filter((row) => row !== null);
            const formattedRows = await Promise.all(formattedRowsPromises);
            setPOData(formattedRows?.reverse() || []);

            const formattedDate = selectedpurchase?.docDate ? formatDateToDatetimeLocal(selectedpurchase?.docDate) : getCurrentLocalDatetime();
            setFormData({
                ...formData,
                InvoiceDate: formattedDate,
                location: { label: selectedpurchase?.fax, value: selectedpurchase?.fax },
                exchangeRate: selectedpurchase?.exchangeRate,
                paymentTerm: selectedpurchase?.terms,
                attention: selectedpurchase?.attention,
                vendorId: selectedpurchase?.vendorId,
                quotationRef: selectedpurchase?.quotationRef,
                faxNo: selectedpurchase?.fax === '0' ? '' : selectedpurchase?.fax ,
                vendorName: selectedpurchase?.vendorName === '0' ? '' : selectedpurchase?.vendorName,
                department: selectedpurchase?.department === '0' ? '' : selectedpurchase?.department,
                contactPerson: selectedpurchase?.contactPerson === '0' ? '' : selectedpurchase?.contactPerson,
                contactNo: selectedpurchase?.contactNo === '0' ? '' : selectedpurchase?.contactNo,
                footNote: selectedpurchase?.remarks === '0' ? '' : selectedpurchase?.remarks,
                deliveryPoint: selectedpurchase?.deliveryPoint === '0' ? '' : selectedpurchase?.deliveryPoint,
                currency: selectedpurchase?.currencyCode,
                costCenter1: selectedpurchase?.costCenter1 === '0' ? '' : selectedpurchase?.costCenter1,
                costCenter2: selectedpurchase?.costCenter2 === '0' ? '' : selectedpurchase?.costCenter2,
            });
            setIsLoader(false)
        }
        setIsLoader(false)
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleBackClick = () => {
        window.history.back();
    };

    const handleReset = () => {
        setFormData({
            GRNNO: '',
            deliveryNote: '',
            remarks: '',
            InvoiceNo: '',
            InvoiceDate: getCurrentLocalDatetime(),
            deliveryDate: getCurrentLocalDatetime(),
            TaxInvoice: '',
            costCenter1: '',
            costCenter2: '',
            costCenter3: '',
            costCenter4: '',
            Currency: '',
            exchangeRate: '',
            deliveryPoint: '',
            PurchaseOrderDate: '',
            contactPerson: '',
            contatNo: '',
            taskCode: '',
            email: '',
            subcatname: '',
            location: [],
        });
        setExpenseType(null);
        setSelectedRequisition(null);
        setRequisitionList([]);
    }

    const preventNegativeSign = (e) => {
        if (e.key === '-' || e.key === '+') {
            e.preventDefault();
        }
    };

    const handleClearFilters = () => {
        setFormData({
            paymentTerm: '',
            attention: '',
            vendorId: '',
            quotationRef: '',
            InvoiceDate: getCurrentLocalDatetime(),
            faxNo: '',
            vendorName: '',
            department: '',
            contactPerson: '',
            footNote: '',
            deliveryPoint: '',
            currency: '',
            exchangeRate: '',
            contactNo: '',
            costCenter1: '',
            costCenter2: '',
            costCenter3: '',
            costCenter4: '',
        });
        setPOlist([])
        setSelectedPO([]);
        setSelectedPOData([])
        setPOData([])
    }
    const handleSuppChange = async (val) => {
        setSupplierCheck(val);
        handleClearFilters()
        if (val === "Cancelled") {
            let param = `?DropdownFor=GetForPOsCancellation`
            const response = await apiService.getApiParamater('GET_PR_CASCAD', param);
            let data = response?.data?.items || []
            setPurchaseOrder(data);
        } else {
            let param = `?DropdownFor=GetForPOsClosing`
            const response = await apiService.getApiParamater('GET_PR_CASCAD', param);
            let data = response?.data?.items || []
            setPurchaseOrder(data);
        }
    }

    const handleSave = async () => {
        setLoader(true);
        if (!SelectedPO?.label) {
            toast?.warning("Please Select POrder No")
            setLoader(false);
            return
        }
        if (!formData?.footNote) {
            toast.warning("Enter Remarks")
            setLoader(false);
            return
        }
        const docBody = {
            recordId: selectedPOData?.recordId,
            status: supplierCheck === "Cancelled" ? 3 : 6,
            porderNo: SelectedPO?.label,
            remarks: formData?.footNote
        };
        const docRes = await apiService.put('UPDATE_PO_STATUS', docBody);

        if (docRes?.data?.statusCode === 200 || docRes?.data?.statusCode === 201) {
            toast.success(docRes?.data?.message)
            setLoader(false);
            navigate('/Inventory/Partial');
        } else {
            toast.error(docRes?.data?.message)
            setLoader(false);
        }
    }

    return (
        <div className="p-4">
            <div className="d-flex justify-contant-between ">
                <h5 className="col mainInvHead">PO Cancellation/Closing</h5>
                <div className="d-flex justify-content-end gap-1">
                    <div className="col center">
                        {itemData?.eye === true ? (
                            ' '
                        ) : (
                            <>
                                {loader === true ? (
                                    <button className="mainbtn " type="submit">
                                        <ClipLoader color="#ffffff" size={25} />
                                    </button>
                                ) : (
                                    <button className="mainbtn " onClick={handleSave} type="submit">
                                        <FaSave className="center mt-1 mx-2" /> <div>Save</div>
                                    </button>
                                )}
                            </>
                        )}
                    </div>
                    {itemData?.eye === true ? (
                        ' '
                    ) : (
                        <button className="mainbtnRed" onClick={() => handleReset()}>
                            <RiRefreshLine className="center mt-1 mx-2" />
                            <div>Reset</div>
                        </button>
                    )}
                    <button onClick={handleBackClick} className="mainbtnSecondary">
                        <FaAngleLeft className="center mt-1 mx-2" />
                        <div>Back</div>
                    </button>
                </div>
            </div>
            {isLoader && (
                <div
                    style={{
                        position: 'absolute',
                        inset: 0,
                        background: 'rgba(255,255,255,0.6)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        zIndex: 10,
                    }}
                >
                    <div className="spinner-border text-primary" role="status" />
                </div>
            )}
            <div className="cost-center-section mb-2">
                <div className="d-flex mt-3 cursor-pointer slide-header gap-4" onClick={() => setPurchaseTab(!PurchaseTab)}>
                    <div className="h6 pt-1">PO Details</div>
                </div>
                <div className={`slide-content ${PurchaseTab ? 'open' : 'closed'}`}>
                    <div className="border-box2 p-3">
                        <div className='row pb-3'>
                            <div className='col-3 d-flex gap-5 '>
                                <div className="form-check gap-3 center">
                                    <input
                                        style={{ width: '20px', height: '20px' }}
                                        onClick={() => handleSuppChange('Cancelled')}
                                        checked={supplierCheck === 'Cancelled' ? true : false}
                                        className="form-check-input"
                                        type="radio"
                                        name="flexRadioDefault"
                                        id={supplierCheck}
                                    />
                                    <label className="form-check-label" for="Cancelled">
                                        Cancelled
                                    </label>
                                </div>
                                <div className="form-check gap-3 center">
                                    <input
                                        className="form-check-input"
                                        style={{ width: '20px', height: '20px' }}
                                        type="radio"
                                        name="flexRadioDefault"
                                        id={supplierCheck}
                                        checked={supplierCheck === 'Closed' ? true : false}
                                        onClick={() => handleSuppChange('Closed')}
                                    />
                                    <label className="form-check-label" for="Closed">
                                        Closed
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div className="form-group row pb-3">
                            <div className="col d-flex justify-content-between">
                                <label htmlFor="inventoryAccountCode" className="form-label  pt-1 start">
                                    Purchase Order No *
                                </label>
                                <Select
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 8,
                                        padding: 9,
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }}
                                    className="w-100 p-0"
                                    value={SelectedPO}
                                    options={PurchaseOrder?.map((po) => ({ value: po.text, label: po?.text }))}
                                    onChange={(selectedOption) => handlePoChange(selectedOption)}
                                />
                            </div>
                            <div className="col d-flex justify-content-between">
                                <label htmlFor="PurchaseOrderDate" className="form-label  pt-1 start">Payment Term</label>
                                <input
                                    type="text"
                                    className="form-Input w-100"
                                    disabled={true}
                                    value={formData?.paymentTerm}
                                />
                            </div>
                            <div className="col d-flex justify-content-between">
                                <label htmlFor="PurchaseOrderDate" className="form-label  pt-1 start">Attention</label>
                                <input
                                    type="text"
                                    className="form-Input w-100"
                                    disabled={true}
                                    value={formData?.attention}
                                />
                            </div>
                        </div>
                        <div className="form-group row pb-3">
                            <div className="col d-flex justify-content-between">
                                <label htmlFor="PurchaseOrderDate" className="form-label  pt-1 start">Vendor Id</label>
                                <input
                                    type="text"
                                    className="form-Input w-100"
                                    disabled={true}
                                    value={formData?.vendorId}
                                />
                            </div>
                            <div className="col d-flex justify-content-between">
                                <label htmlFor="PurchaseOrderDate" className="form-label  pt-1 start">Quotation Ref#</label>
                                <input
                                    type="text"
                                    className="form-Input w-100"
                                    disabled={true}
                                    value={formData?.quotationRef}
                                />
                            </div>
                            <div className="col d-flex justify-content-between">
                                <label htmlFor="PurchaseOrderDate" className="form-label  pt-1 start">Fax No</label>
                                <input
                                    type="text"
                                    className="form-Input w-100"
                                    disabled={true}
                                    value={formData?.faxNo}
                                />
                            </div>
                        </div>
                        <div className="form-group row pb-3">
                            <div className="col d-flex justify-content-between">
                                <label htmlFor="PurchaseOrderDate" className="form-label  pt-1 start">Vendor Name</label>
                                <input
                                    type="text"
                                    className="form-Input w-100"
                                    disabled={true}
                                    value={formData?.vendorName}
                                />
                            </div>
                            <div className="col d-flex justify-content-between">
                                <label htmlFor="PurchaseOrderDate" className="form-label  pt-1 start">Department</label>
                                <input
                                    type="text"
                                    className="form-Input w-100"
                                    disabled={true}
                                    value={formData?.department}
                                />
                            </div>
                            <div className="col d-flex justify-content-between">
                                <label htmlFor="PurchaseOrderDate" className="form-label  pt-1 start">Contact Person</label>
                                <input
                                    type="text"
                                    className="form-Input w-100"
                                    disabled={true}
                                    value={formData?.contactPerson}
                                />
                            </div>
                        </div>
                        <div className="form-group row pb-3">
                            <div className="col d-flex justify-content-between">
                                <label htmlFor="InvoiceDate" className="form-label  pt-1 start">
                                    Doc Date
                                </label>
                                <DatePicker
                                    selected={formData.InvoiceDate} disabled
                                    className="p-2 form-Input w-100"
                                    dateFormat="dd-MM-yyyy"
                                />
                            </div>
                            <div className="col d-flex justify-content-between">
                                <label htmlFor="PurchaseOrderDate" className="form-label  pt-1 start">Remarks</label>
                                <textarea
                                    type="text"
                                    onChange={handleInputChange}
                                    name="footNote"
                                    className="form-Input w-100"
                                    value={formData?.footNote}
                                />
                            </div>
                            <div className="col d-flex justify-content-between">
                                <label htmlFor="PurchaseOrderDate" className="form-label  pt-1 start">Delivery Point</label>
                                <input
                                    type="text"
                                    className="form-Input w-100"
                                    disabled={true}
                                    value={formData?.deliveryPoint}
                                />
                            </div>
                        </div>
                        <div className="form-group row pb-3">
                            <div className="col d-flex justify-content-between">
                                <label htmlFor="PurchaseOrderDate" className="form-label  pt-1 start">Currency</label>
                                <input
                                    type="text"
                                    className="form-Input w-100"
                                    disabled={true}
                                    value={formData?.currency}
                                />
                            </div>
                            <div className="col d-flex justify-content-between">
                                <label htmlFor="PurchaseOrderDate" className="form-label  pt-1 start">Exchange Rate</label>
                                <input
                                    type="text"
                                    className="form-Input w-100"
                                    disabled={true}
                                    value={formData?.exchangeRate}
                                />
                            </div>
                            <div className="col d-flex justify-content-between">
                                <label htmlFor="PurchaseOrderDate" className="form-label  pt-1 start">Contact No</label>
                                <input
                                    type="text"
                                    className="form-Input w-100"
                                    disabled={true}
                                    value={formData?.contactNo}
                                />
                            </div>
                        </div>
                        <div className="form-group row pb-3">
                            <div className="col d-flex justify-content-between">
                                <label htmlFor="PurchaseOrderDate" className="form-label  pt-1 start">Property</label>
                                <input
                                    type="text"
                                    className="form-Input w-100"
                                    disabled={true}
                                    value={formData?.costCenter1}
                                />
                            </div>
                            <div className="col d-flex justify-content-between">
                                <label htmlFor="PurchaseOrderDate" className="form-label  pt-1 start">Unit</label>
                                <input
                                    type="text"
                                    className="form-Input w-100"
                                    disabled={true}
                                    value={formData?.costCenter2}
                                />
                            </div>
                            <div className="col d-flex justify-content-between">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className={`slide-content open`}>
                <div className={`grid-1 border-box2 p-3`}>
                    <ItemGridGRN
                        onRequisitionData={handleRequisitionData}
                        itemData={POData} setItemData={setItemData}
                        grnData={itemData}
                        selectedPOData={selectedPOData}
                        currencyPrecision={currencyPrecision?.exp1 || 3}
                    />
                </div>
            </div>
        </div>
    );
};

export default CreatePartialPO;
